var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
              },
              [
                _vm.popupParam.psiProtectionEpuipmentId
                  ? _c(
                      "c-card",
                      {
                        staticClass: "cardClassDetailForm revisionLayout",
                        attrs: { title: "LBLREV", topClass: "topcolor-orange" },
                      },
                      [
                        _c("template", { slot: "card-detail" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "LBLREVNO",
                                        name: "revisionNum",
                                      },
                                      model: {
                                        value: _vm.data.revisionNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "revisionNum", $$v)
                                        },
                                        expression: "data.revisionNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-2" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "LBLREVPERIOD",
                                        name: "regDtStr",
                                      },
                                      model: {
                                        value: _vm.data.regDtStr,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regDtStr", $$v)
                                        },
                                        expression: "data.regDtStr",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-1" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        editable: false,
                                        label: "LBLREVUSER",
                                        name: "regUserName",
                                      },
                                      model: {
                                        value: _vm.data.regUserName,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "regUserName", $$v)
                                        },
                                        expression: "data.regUserName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-4" },
                                  [
                                    _c("c-moc", {
                                      attrs: {
                                        editable: _vm.editable,
                                        isSubmit: _vm.saveCallData,
                                        document: _vm.data,
                                        documentId:
                                          _vm.data.psiProtectionEpuipmentId,
                                        documentTitle: "areaName",
                                        mocRelatedTaskCd: "RT00000001",
                                        label: "LBLMOCNO",
                                        name: "sopMocId",
                                      },
                                      on: {
                                        "update:document": function ($event) {
                                          _vm.data = $event
                                        },
                                      },
                                      model: {
                                        value: _vm.data.sopMocId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.data, "sopMocId", $$v)
                                        },
                                        expression: "data.sopMocId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "col-4" },
                                  [
                                    _c("c-text", {
                                      attrs: {
                                        required:
                                          _vm.editable && _vm.isRevision,
                                        editable:
                                          _vm.editable && _vm.isRevision,
                                        label: "LBLREVREASON",
                                        name: "revisionContent",
                                      },
                                      model: {
                                        value: _vm.data.revisionContent,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.data,
                                            "revisionContent",
                                            $$v
                                          )
                                        },
                                        expression: "data.revisionContent",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
              },
              [
                _c(
                  "c-card",
                  {
                    staticClass: "cardClassDetailForm",
                    attrs: { title: "LBL0010564" },
                  },
                  [
                    _c(
                      "template",
                      { slot: "card-select" },
                      [
                        _vm.popupParam.psiProtectionEpuipmentId
                          ? _c("c-select", {
                              attrs: {
                                editable: !_vm.isRevision,
                                comboItems: _vm.gridrev.data,
                                type: "custom",
                                typetext: "LBL0010565",
                                itemText: "revisionNum",
                                itemValue: "psiProtectionEpuipmentId",
                                name: "selectedpsiProtectionEpuipmentId",
                                label: "LBL0010565",
                              },
                              on: { input: _vm.rowClickRev },
                              model: {
                                value: _vm.selectedpsiProtectionEpuipmentId,
                                callback: function ($$v) {
                                  _vm.selectedpsiProtectionEpuipmentId = $$v
                                },
                                expression: "selectedpsiProtectionEpuipmentId",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "template",
                      { slot: "card-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "custom-btn",
                                attrs: {
                                  icon: "help",
                                  color: "deep-purple-6",
                                  "text-color": "white",
                                  align: "center",
                                  round: "",
                                },
                              },
                              [
                                _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "bottom left",
                                      self: "top left",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustomTop" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$label("LBL0010385")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "tooltipCustom" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$message("MSG0010060"))
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$message("MSG0010061")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.psiProtectionEpuipmentId &&
                                    !_vm.isRevision,
                                  expression:
                                    "editable && popupParam.psiProtectionEpuipmentId && !isRevision",
                                },
                              ],
                              attrs: { label: "LBLREV", icon: "restart_alt" },
                              on: { btnClicked: _vm.SetRevision },
                            }),
                            _c("c-btn", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.editable &&
                                    _vm.popupParam.psiProtectionEpuipmentId &&
                                    _vm.isRevision,
                                  expression:
                                    "editable && popupParam.psiProtectionEpuipmentId && isRevision",
                                },
                              ],
                              attrs: {
                                label: "LBLREVCANCEL",
                                icon: "restart_alt",
                              },
                              on: { btnClicked: _vm.CancelRevision },
                            }),
                            _vm.editable
                              ? _c("c-btn", {
                                  attrs: {
                                    url: _vm.saveUrl,
                                    isSubmit: _vm.isSave,
                                    param: _vm.data,
                                    mappingType: _vm.mappingType,
                                    label: "LBLSAVE",
                                    icon: "save",
                                  },
                                  on: {
                                    beforeAction: _vm.saveData,
                                    btnCallback: _vm.saveCallback,
                                  },
                                })
                              : _vm._e(),
                            _vm.editable &&
                            _vm.popupParam.psiProtectionEpuipmentId
                              ? _c("c-btn", {
                                  attrs: { label: "LBLREMOVE", icon: "remove" },
                                  on: { btnClicked: _vm.deleteData },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("template", { slot: "card-detail" }, [
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("c-select", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              codeGroupCd: "SAFETY_EQUIP_TYPE_CD",
                              type: "edit",
                              itemText: "codeName",
                              itemValue: "code",
                              name: "safetyEquipTypeCd",
                              label: "LBL0010557",
                            },
                            model: {
                              value: _vm.data.safetyEquipTypeCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "safetyEquipTypeCd", $$v)
                              },
                              expression: "data.safetyEquipTypeCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "LBL0010551",
                              name: "manageNo",
                            },
                            model: {
                              value: _vm.data.manageNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "manageNo", $$v)
                              },
                              expression: "data.manageNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-4" },
                        [
                          _c("c-plant", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              type: "edit",
                              name: "plantCd",
                            },
                            model: {
                              value: _vm.data.plantCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "plantCd", $$v)
                              },
                              expression: "data.plantCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "LBL0010552",
                              name: "areaName",
                            },
                            model: {
                              value: _vm.data.areaName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "areaName", $$v)
                              },
                              expression: "data.areaName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-text", {
                            attrs: {
                              required: true,
                              editable: _vm.editable,
                              label: "LBL0010559",
                              name: "itemName",
                            },
                            model: {
                              value: _vm.data.itemName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "itemName", $$v)
                              },
                              expression: "data.itemName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010608",
                              name: "location",
                            },
                            model: {
                              value: _vm.data.location,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "location", $$v)
                              },
                              expression: "data.location",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-text", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0010473",
                              name: "checkCycle",
                            },
                            model: {
                              value: _vm.data.checkCycle,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "checkCycle", $$v)
                              },
                              expression: "data.checkCycle",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("c-textarea", {
                            attrs: {
                              editable: _vm.editable,
                              rows: 3,
                              label: "LBLREMARK",
                              name: "remarks",
                            },
                            model: {
                              value: _vm.data.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "remarks", $$v)
                              },
                              expression: "data.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-process", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0001705",
                              multiple: "single",
                              name: "processCd",
                            },
                            model: {
                              value: _vm.data.processCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "processCd", $$v)
                              },
                              expression: "data.processCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("c-dept", {
                            attrs: {
                              editable: _vm.editable,
                              label: "LBL0001721",
                              name: "deptCd",
                            },
                            model: {
                              value: _vm.data.deptCd,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "deptCd", $$v)
                              },
                              expression: "data.deptCd",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6",
              },
              [
                _c(
                  "c-table",
                  {
                    ref: "grid",
                    attrs: {
                      title: "LBL0010560",
                      tableId: "grid",
                      columns: _vm.grid.columns,
                      data: _vm.grid.data,
                      selection: "multiple",
                      rowKey: "psiProtectionEpuipmentDetailId",
                      isFullScreen: false,
                      columnSetting: false,
                      filtering: false,
                      gridHeight: "422px",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "table-button" },
                      [
                        _c(
                          "q-btn-group",
                          { attrs: { outline: "" } },
                          [
                            _vm.editable &&
                            _vm.popupParam.psiProtectionEpuipmentId
                              ? _c("c-btn", {
                                  attrs: { label: "LBLADD", icon: "add" },
                                  on: { btnClicked: _vm.addrow },
                                })
                              : _vm._e(),
                            _vm.editable &&
                            _vm.popupParam.psiProtectionEpuipmentId
                              ? _c("c-btn", {
                                  attrs: { label: "LBLREMOVE", icon: "remove" },
                                  on: { btnClicked: _vm.deleteItem },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }